// removed by extract-text-webpack-plugin
module.exports = {"navBar":"_3uHzYmTGgR7zuFAX436yvC","navMenu":"_3KZR8rFllgNPK1HJWRkpS5","section":"_2iZv84FMdT7rdSPtu52j9R","justRight":"vwqCysUizHFdkeECloCql","item":"A0oK5XFzsMzmhWUP-pP5Y","textContainer":"_1TwbRbA7nhh9TX-x5tQ3Fm","active":"AmBLD1vYwd7We8DL51VBG","iconContainer":"_1RpAqMBc-XjvPTZ92CZHdo","avatarIcon":"_21OESEl0jyAfBZvC0AgxWm","brandContainer":"mYnqgmn89h6mSGkaB0KZ"};


//////////////////
// WEBPACK FOOTER
// ./elements/navBar.scss
// module id = 1186
// module chunks = 0